import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import dynamic from "next/dynamic";
const DynamicShare = dynamic(()=>import("./DynamicShare").then((mod)=>mod.DynamicShare), {
    loadableGenerated: {
        webpack: ()=>[
                require.resolveWeak("./DynamicShare")
            ]
    },
    suspense: false,
    ssr: false
});
export function Share(props) {
    return /*#__PURE__*/ _jsx(DynamicShare, {
        ...props
    });
}
